import { Company } from '../models/companyModel'
import { Contract, CreateContract, GenerateEmbedContractUrl } from '../models/contractModels'
import { User } from '../models/userModel'
import { trackEvent } from '../utils/analyticsUtils'
import { resolveApiUrl } from '../utils/requestsUtils'
import { RequestResponse, requestService } from './requestServices'

export const createGuarantorContractService = async (
    payload: CreateContract,
    companyId: Company['id'],
    memberId: string | undefined
): Promise<RequestResponse<Contract> | undefined> => {
    const url = resolveApiUrl('guarantorContract.create', { variables: { companyId, memberId } })

    const contractCreatePayload: Omit<CreateContract, 'returnUrl'> = {
        currency: payload.currency,
        debtorId: payload.debtorId,
        language: payload.language,
        type: 'guarantor'
    }

    const response = await requestService<Contract>(url, {
        method: 'POST',
        data: contractCreatePayload
    })

    trackEvent('Create_Contract_Guarantor')

    return response
}

export const generateEmbedContractUrlService = (
    payload: GenerateEmbedContractUrl
): Promise<RequestResponse<string> | undefined> => {
    const { companyId, memberId, debtorId } = payload
    const url = resolveApiUrl('guarantorContract.generateEmbed', { variables: { companyId, memberId } })

    return requestService(url, { method: 'POST', data: { returnUrl: payload.returnUrl, debtorId } })
}

export type CreateUserContract = {
    companyId: string
    userId: string
}

export const createUserContractService = async ({ companyId, userId }: CreateUserContract) => {
    const url = resolveApiUrl('contract.create', { variables: { companyId, userId } })
    const response = await requestService<User>(url, { method: 'POST' })
    trackEvent('Create_Contract_User')
    return response
}

export type ResendUserContract = {
    companyId: string
    userId: string
}

export const resendUserContractService = async ({ companyId, userId }: ResendUserContract) => {
    const url = resolveApiUrl('contract.resend', { variables: { companyId, userId } })
    const response = await requestService<void>(url, { method: 'POST' })
    trackEvent('Resend_Contract_User')
    return response
}
